import { useLayoutEffect, useRef } from 'react'

/** Extra sticky chrome below the base meetings header offset (preset chip row height). */
export const MEETINGS_PRESET_TABS_BAND_CSS_VAR = '--meetings-preset-tabs-band'

/**
 * Publishes the preset tabs row height so fixed controls (e.g. scroll-to-today) can sit
 * below the chip row instead of overlapping it.
 */
export const useMeetingsPresetTabsScrollBand = (enabled) => {
  const rowRef = useRef(null)

  useLayoutEffect(() => {
    if (!enabled) {
      document.documentElement.style.removeProperty(MEETINGS_PRESET_TABS_BAND_CSS_VAR)
      return undefined
    }

    const node = rowRef.current
    if (!node) return undefined

    const syncBand = () => {
      document.documentElement.style.setProperty(
        MEETINGS_PRESET_TABS_BAND_CSS_VAR,
        `${node.offsetHeight}px`,
      )
    }

    syncBand()

    const observer = new ResizeObserver(syncBand)
    observer.observe(node)

    return () => {
      observer.disconnect()
      document.documentElement.style.removeProperty(MEETINGS_PRESET_TABS_BAND_CSS_VAR)
    }
  }, [enabled])

  return rowRef
}
